const recentActionsLocale = {
  recentActions: {
    recentActions: "Actions récentes",
    lastCall: "Dernier appel",
    lastHardwareConfiguration: "Dernière configuration matérielle",
    lastSoftwareUpdate: "Dernière mise à jour logicielle",
  },
};

export type RecentActionsLocale = typeof recentActionsLocale;
export default recentActionsLocale;
